module.exports = __webpack_public_path__ + "img/EMDR.303e80e8.png";